import { WriteOffType } from '@repo/types';

import { useDarkMode } from '@xtnd/web/shared';

import useWriteOffType from '../../hooks/useWriteOffType';

export const ArWriteOffType = ({ type, isStrikeThrough }: { type: WriteOffType; isStrikeThrough?: boolean }) => {
  const { isDark } = useDarkMode();
  const mode = isDark ? 'dark' : 'light';
  const { getTypeLabel, getTypeColor } = useWriteOffType(mode);

  const label = getTypeLabel(type);
  const labelColor = getTypeColor(type);

  return (
    <span
      className={`text-sm inline-flex items-center px-2 py-1 rounded-full border ${labelColor} truncate ${isStrikeThrough ? 'line-through opacity-60' : ''}`}
      title={label}
    >
      {label}
    </span>
  );
};
